import { api } from './api';

export type FeedKind =
  | 'google_news'
  | 'rss'
  | 'api'
  | 'serp_trends'
  | 'serp_events'
  | 'serp_finance'
  | 'mos'
  | 'fabrica';
export type ProcMode = '1x1' | 'multi_fonte' | 'enriquecer' | 'dados' | 'template';
export type Mode = 'auto' | 'semi' | 'off';
export type Estado = 'no_ar' | 'migrar' | 'nova';

export interface Editoria {
  slug: string;
  client_id?: string;
  nome: string;
  estado: Estado;
  modo: Mode;
  ordem: number;
  feed: {
    kind: FeedKind;
    fonte: string;
    query?: string; // termo de busca (google_news)
    url?: string; // URL do feed (rss) ou tópico pré-configurado
    fabrica?: 'loterias' | 'mercado' | 'clima'; // qual fábrica (kind=fabrica)
    jogos?: string[]; // loterias
    simbolos?: string[]; // mercado (tickers B3 + ^BVSP)
    cidades?: string[]; // clima (slugs)
    itens?: number;
    intervalo: string;
    /** Frescor máximo do item do feed ("24h", "48h", "7d"). Vazio = sem filtro. */
    janela_frescor?: string;
    location?: string; // serp_events: cidade (geolocalização)
    cidade?: string; // serp_events: nome COM acento p/ título ("São Paulo"); vazio usa location
    periodo?: string; // serp_events: today | weekend | next_week
    ticker?: string; // serp_finance: papel (ex.: ABEV3:BVMF); vazio = painel geral
    trend?: string; // serp_finance painel: indexes | most-active | gainers | losers
  };
  proc: { mode: ProcMode; modelo: string | null; dedup: boolean };
  pub: {
    sites: string[];
    categoria: string;
    categoria_id?: number;
    autor: string;
    status: 'publish' | 'draft';
    porHora: number;
  };
  flags: string[];
}

export type EditoriaPatch = Partial<Omit<Editoria, 'slug'>>;

export interface IngestResult {
  slug: string;
  total: number;
  novos: number;
  duplicados: number;
  dedup: boolean;
  itens: { titulo: string; url: string; novo: boolean }[];
}

export interface RunResult {
  slug: string;
  gerado: boolean;
  motivo?: string;
  dry_run?: boolean;
  mode?: string;
  modelo?: string;
  custo_usd?: number;
  texto_fonte?: string;
  fontes?: { titulo: string; url: string }[];
  titulo?: string;
  html?: string;
  status_destino?: string;
  wp_id?: number;
  wp_link?: string;
}

export const editoriasApi = {
  list: (): Promise<Editoria[]> => api.get<Editoria[]>('/editorias'),
  get: (slug: string): Promise<Editoria> => api.get<Editoria>(`/editorias/${slug}`),
  patch: (slug: string, patch: EditoriaPatch): Promise<Editoria> =>
    api.put<Editoria>(`/editorias/${slug}`, patch),
  ingest: (slug: string): Promise<IngestResult> =>
    api.post<IngestResult>(`/editorias/${slug}/ingest`),
  run: (slug: string): Promise<RunResult> =>
    api.post<RunResult>(`/editorias/${slug}/run?dry_run=true`),
  publish: (slug: string): Promise<RunResult> =>
    api.post<RunResult>(`/editorias/${slug}/run?dry_run=false`),
  publishLive: (slug: string): Promise<RunResult> =>
    api.post<RunResult>(`/editorias/${slug}/run?dry_run=false&publish=true`),
  ultimas: (slug: string): Promise<UltimasResult> =>
    api.get<UltimasResult>(`/editorias/${slug}/ultimas`),
};

export interface UltimaItem {
  tema: string;
  estado: string;
  wp_link?: string | null;
  wp_site?: string | null;
  criada_em?: string | null;
}
export interface UltimasResult {
  slug: string;
  itens: UltimaItem[];
}
